// Build-time constants for the staging build (project.json's `staging` configuration
// replaces environment.ts with this file). Identical to environment.prod.ts on purpose:
// everything that differs per environment is served at runtime as SERVER_CONFIG from
// /env.config.js, generated per hostname from config/<tier>/hosts/<hostname>/env.config.js.
export const environment = {
  production: true,
  test: false,
  web: true,
  isCB: false,
  sentryUrl: 'https://1e21209233de81f6a5bc701039550c96@o113114.ingest.us.sentry.io/4509531325661184',
  sentryShowDialog: false,
  imageServer: 'https://d20xk4sxen1bs2.cloudfront.net',
  includeLegs: true,
  haveCommunicationHander: true,
  allEndpointsWithCredentials: false,
  xpointKey: null,
  core: {
    customSessionExpireRedirect: false,
    trackingPageTitle: 'Mido'
  }
};
